// (function () {
//     'use strict';

//     angular.module("imApp").factory("csvExportsService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listCsvExports: function (parms) {
//                 return $ihttp.post({
//                     method: 1526,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
